
define('text!templates/breadcrumb.ejs',[],function () { return '<% items.forEach(function(item) { if (item.isLast) { %>\n    <li class="active"><%= i18n.t(item.title) %></li>\n<% } else { %>\n    <li><a href="<%= url(item.action, item.params, item.query) %>"><%= i18n.t(item.title) %></a> <span class="divider">/</span></li>\n<% }}) %>';});

